import { dataLineChart } from 'dls-icons-data'
import { createIcon } from '../common'

const IconLineChart = /*#__PURE__*/createIcon(dataLineChart)
export default IconLineChart
